import { fetch } from "@deere/scs-fetch";
import { URL_SURVEY_API } from "../utils/constEnvVariables";

export const getSurveyPartsBySupplier = async (assignments, campaignId, accessToken, isAuthMethodOkta) => {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  let requestOptions = 
    isAuthMethodOkta !== undefined && !isAuthMethodOkta 
    ? 
      {
        method: 'POST',
        body: JSON.stringify({
            assignments: assignments,
            campaignId: campaignId
        })
      } 
    :
      {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
            assignments: assignments,
            campaignId: campaignId
        })
      };
  if(campaignId && Array.isArray(assignments) && assignments.length > 0){
    return fetch(`${URL_SURVEY_API}/${pathParam}/parts/`, requestOptions)
  }
  return undefined
}

export const getSurveyPartsHistoryBySupplier = async (suppliers, code, campaignId, accessToken, isAuthMethodOkta, isNonDeere, dataArray) => {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  let requestOptions = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? 
      {
        method: 'POST',
        body: JSON.stringify({
          data:dataArray,
          survey: code,
          isNonDeere: isNonDeere
        })
      } 
    :
      {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
            data:dataArray,
            survey: code,
            isNonDeere: isNonDeere
        })
      };
  if(campaignId && Array.isArray(suppliers) && suppliers.length > 0){
    return fetch(`${URL_SURVEY_API}/${pathParam}/parts/historical`, requestOptions)
    .then((res)=>{
      return res;
      })
      .catch((err)=>{
        console.log(err)
      })
  }
}

export const getResponsesByAssignmentSurveypart = function (assignmentId, accessToken, isNonDeere, isAuthMethodOkta) {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  let requestOptions = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? { method: "GET" } : { method: "GET", headers: { Authorization: `Bearer ${accessToken}` } };
  return fetch(`${URL_SURVEY_API}/${pathParam}/responses/${assignmentId}/${isNonDeere}`, requestOptions)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.log(error);
      return [];
    });
};

export const getResponseByIdSurveypart = function (responseId, accessToken, isNonDeere, isAuthMethodOkta) {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  let requestOptions = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? { method: "GET" } : { method: "GET", headers: { Authorization: `Bearer ${accessToken}` } };
  return fetch(`${URL_SURVEY_API}/${pathParam}/response/${responseId}/${isNonDeere}`, requestOptions)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.log(error);
      return [];
    });
};

export const deleteResponseByResponseIdSurveypart = function (responseId, accessToken, isNonDeere, isAuthMethodOkta) {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  let requestOptions = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? { method: "DELETE" } : { method: "DELETE", headers: { Authorization: `Bearer ${accessToken}` } };

  return fetch(`${URL_SURVEY_API}/${pathParam}/response/${responseId}/${isNonDeere}`, requestOptions)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const saveSurveyPartAnswers = function (request, accessToken, isAuthMethodOkta) {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  let requestOptions = 
    isAuthMethodOkta !== undefined && !isAuthMethodOkta 
    ? 
      {
        method: "POST",
        body: JSON.stringify(request),
      }
    : {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(request),
      };

  return fetch(`${URL_SURVEY_API}/${pathParam}/answer`, requestOptions)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const submitSurveyPartResponse = function (request, accessToken, isAuthMethodOkta) {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  let requestOptions = 
  isAuthMethodOkta !== undefined && !isAuthMethodOkta 
  ? 
    {
      method: "PATCH",
      body: JSON.stringify(request),
    }
  : {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(request),
    };

  return fetch(`${URL_SURVEY_API}/${pathParam}/response`, requestOptions)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllSurveyPartsRequestedByAssignment = function (assignmentId, accessToken, isNonDeere, isAuthMethodOkta) {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  const requestOptions = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? { method: 'GET' } : { method: 'GET', headers: { 'Authorization': `Bearer ${accessToken}` } };
  return fetch(`${URL_SURVEY_API}/${pathParam}/assignment/${assignmentId}/part/${isNonDeere}`, requestOptions)
      .then(response => {
          return response
      })
      .catch(error => { throw error });
}

export const getSurveyPartAttachmentsList = function (surveyCode, assignmentId, accessToken, isAuthMethodOkta) {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  const requestOptions = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? { method: 'GET' } : { method: 'GET', headers: { 'Authorization': `Bearer ${accessToken}` } };
  return fetch(`${URL_SURVEY_API}/${pathParam}/attachments/${surveyCode}/${assignmentId}`, requestOptions)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteSurveyPartAttachment = function (surveyCode, assignmentId, fileName, accessToken, isAuthMethodOkta) {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  let requestOptions = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? { method: "DELETE" } : { method: "DELETE", headers: { Authorization: `Bearer ${accessToken}` } };
  return fetch(`${URL_SURVEY_API}/${pathParam}/attachment/${surveyCode}/${assignmentId}/${fileName}`, requestOptions)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
}

export const deleteSurveyByPartAttachment = function (fileName, surveyCode, campaignId, assignmentId,partId, queId, accessToken, isAuthMethodOkta) {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  let requestOptions = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? { method: "DELETE" } : { method: "DELETE", headers: { Authorization: `Bearer ${accessToken}` } };
  return fetch(`${URL_SURVEY_API}/${pathParam}/attachment/parts/${surveyCode}/${campaignId}/${assignmentId}/${partId}/${queId}/${fileName}`, requestOptions)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
}